import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getMembershipStatusColor } from "../../../exports/functions";

export interface DropdownOption {
  label: string;
  value: string;
  color?: string;
}

interface CustomDropdownProps {
  label?: string;
  value: string;
  onChange: (val: string) => void;
  options: string[];
}

const StatusDropDown: React.FC<CustomDropdownProps> = ({
  label = "",
  value,
  onChange,
  options,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`become-volunteer__input`}
      style={{ position: "relative", marginBottom: "16px" }}
      ref={dropdownRef}
    >
      {label && <span style={{ fontSize: 14 }}>{label}</span>}
      <div
        className="custom-select-style"
        onClick={() => setOpen((prev) => !prev)}
        tabIndex={0}
        style={getMembershipStatusColor(value)}
      >
        {value ?? label}
        <span className="arrow">
          <KeyboardArrowDownIcon fontSize="small" />
        </span>
      </div>

      {open && (
        <div className="custom-dropdown-options" style={{top: '100%'}}>
          {options.map((opt, index) =>
            index === 0 ? (
              <div className="radio-option disabled-option" key={opt}>
                {opt}
              </div>
            ) : (
              <label className="radio-option" key={opt} style={getMembershipStatusColor(opt)}>
                <input
                  type="radio"
                  name={label}
                  value={opt}
                  checked={value === opt}
                  onChange={(e) => {
                    onChange(e.target.value);
                    setOpen(false);
                  }}
                  style={{ accentColor: getMembershipStatusColor(opt).color }}
                />
                {opt}
              </label>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default StatusDropDown;
